import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./RoomCard.css";
import { PostData } from "../../services/PostData";
import Swal from "sweetalert2";

import subastaRoomIcon from "../../images/subastaRoomIcon.png";
import classicRoomIcon from "../../images/classicRoomIcon.png";
import publicRoomIcon from "../../images/publicRoomIcon.svg";
import tomyPopUp from "../../images/tomyPopUp.png";

class RoomCard extends Component {
  constructor(props) {
    super(props);
    //console.log('datos ficha:',this.props.roomData);
    const roomData = { ...this.props.roomData };
    this.state = { ...roomData };
    console.log("roomdata: ", this.state.roomData);
    this.getMatchData = this.getMatchData.bind(this);
    this.copyRoomLink = this.copyRoomLink.bind(this);
    this.setMatchStatusText = this.setMatchStatusText.bind(this);
  }

  componentDidMount() {
    this.getMatchData();
  }

  getMatchData() {
    let postData = {
      match_id: this.state.match_id,
    };
    PostData("getMatchData", postData).then((result) => {
      let responseJson = result;
      let matchData = responseJson.matchData[0];
      this.setState(
        {
          matchName: matchData.name,
          matchDate: matchData.date,
          matchHour: matchData.hour,
        },
        () => {
          this.setMatchStatusText();
        },
      );
      this.setState({ loading: false });
    });
  }

  setMatchStatusText() {
    if (this.state.status === "1") {
      this.setState({ matchStatusText: "Activa" }, () => {
        //console.log(this.state.matchStatusText);
      });
    }
    if (this.state.status === "4") {
      this.setState({ matchStatusText: "Cerrada" }, () => {
        //console.log(this.state.matchStatusText);
      });
    }
  }

  copyRoomLink() {
    let roomLink = `https://app.subastafutbolera.com/rooms/${this.state.sku}`;
    let matchName = this.state.matchName || "";
    let shareText = `¡Hey!, te invito a jugar ${matchName} en Subasta Futbolera. Ingresa a: ${roomLink} y libera la bestia!`;
    let encodedText = encodeURIComponent(shareText);
    let encodedUrl = encodeURIComponent(roomLink);
    let shareTitle = encodeURIComponent("Subasta Futbolera");
    Swal.fire({
      imageUrl: tomyPopUp,
      imageWidth: 85,
      imageHeight: 130,
      title: "¡Comparte tu sala!",
      html: `
        <p style="color:#555;margin-bottom:16px;">Invita a tus amigos y que empiece la subasta</p>
        <div id="swal-share-grid" style="display:grid;grid-template-columns:repeat(3,1fr);gap:14px;margin:8px auto 20px;max-width:240px;justify-items:center;">
          <a href="https://wa.me/?text=${encodedText}" target="_blank" rel="noopener noreferrer" class="swal-share-icon" data-network="whatsapp" aria-label="Compartir en WhatsApp">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="22" height="22"><path d="M17.6 6.31999C16.8669 5.58141 15.9943 4.99596 15.033 4.59767C14.0716 4.19938 13.0406 3.99622 12 3.99999C10.6089 4.00135 9.24248 4.36819 8.03771 5.06377C6.83294 5.75935 5.83208 6.75926 5.13534 7.96335C4.4386 9.16745 4.07046 10.5335 4.06776 11.9246C4.06507 13.3158 4.42793 14.6832 5.12 15.89L4 20L8.2 18.9C9.35975 19.5452 10.6629 19.8891 11.99 19.9C14.0997 19.9001 16.124 19.0668 17.6222 17.5816C19.1205 16.0965 19.9715 14.0796 19.99 11.97C19.983 10.9173 19.7682 9.87634 19.3581 8.9068C18.948 7.93725 18.3505 7.05819 17.6 6.31999ZM12 18.53C10.8177 18.5308 9.65701 18.213 8.64 17.61L8.4 17.46L5.91 18.12L6.57 15.69L6.41 15.44C5.55925 14.0667 5.24174 12.429 5.51762 10.8372C5.7935 9.24545 6.64361 7.81015 7.9069 6.80322C9.1702 5.79628 10.7589 5.28765 12.3721 5.37368C13.9853 5.4597 15.511 6.13441 16.66 7.26999C17.916 8.49818 18.635 10.1735 18.66 11.93C18.6442 13.6859 17.9355 15.3645 16.6882 16.6006C15.441 17.8366 13.756 18.5301 12 18.53ZM15.61 13.59C15.41 13.49 14.44 13.01 14.26 12.95C14.08 12.89 13.94 12.85 13.81 13.05C13.6144 13.3181 13.404 13.5751 13.18 13.82C13.07 13.96 12.95 13.97 12.75 13.82C11.6097 13.3694 10.6597 12.5394 10.06 11.47C9.85 11.12 10.26 11.14 10.64 10.39C10.6681 10.3359 10.6827 10.2759 10.6827 10.215C10.6827 10.1541 10.6681 10.0941 10.64 10.04C10.64 9.93999 10.19 8.95999 10.03 8.56999C9.87 8.17999 9.71 8.23999 9.58 8.22999H9.19C9.08895 8.23154 8.9894 8.25465 8.898 8.29776C8.8066 8.34087 8.72546 8.403 8.66 8.47999C8.43562 8.69817 8.26061 8.96191 8.14676 9.25343C8.03291 9.54495 7.98287 9.85749 8 10.17C8.0627 10.9181 8.34443 11.6311 8.81 12.22C9.6622 13.4958 10.8301 14.5293 12.2 15.22C12.9185 15.6394 13.7535 15.8148 14.58 15.72C14.8552 15.6654 15.1159 15.5535 15.345 15.3915C15.5742 15.2296 15.7667 15.0212 15.91 14.78C16.0428 14.4856 16.0846 14.1583 16.03 13.84C15.94 13.74 15.81 13.69 15.61 13.59Z" fill="currentColor"></path></svg>
          </a>
          <a href="https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}" target="_blank" rel="noopener noreferrer" class="swal-share-icon" data-network="facebook" aria-label="Compartir en Facebook">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
          </a>
          <a href="https://twitter.com/intent/tweet?text=${encodedText}" target="_blank" rel="noopener noreferrer" class="swal-share-icon" data-network="twitter" aria-label="Compartir en X">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4l7.07 8.51L4.5 20H7l5.39-6.21L16.5 20H20l-7.46-8.95L19.5 4H17l-4.85 5.66L8 4H4z"></path></svg>
          </a>
          <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" class="swal-share-icon" data-network="instagram" aria-label="Compartir en Instagram">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
          </a>
          <a href="https://t.me/share/url?url=${encodedUrl}&text=${encodedText}" target="_blank" rel="noopener noreferrer" class="swal-share-icon" data-network="telegram" aria-label="Compartir en Telegram">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>
          </a>
          <a href="mailto:?subject=${shareTitle}&body=${encodedText}" class="swal-share-icon" data-network="email" aria-label="Compartir por Email">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
          </a>
        </div>
        <div style="display:flex;align-items:center;border:1px solid #ccc;border-radius:8px;padding:10px 12px;background:#f9f9f9;gap:10px;">
          <span style="flex:1;word-break:break-all;font-size:14px;color:#333;">${roomLink}</span>
          <button id="swal-copy-btn" style="background-color:#0066cc;color:white;border:none;border-radius:20px;padding:8px 20px;font-size:14px;font-weight:bold;cursor:pointer;white-space:nowrap;transition:all 0.3s ease;display:flex;align-items:center;gap:6px;">Copiar</button>
        </div>
        <p style="color:#888;margin-top:16px;font-size:13px;">Pega el link en tus redes sociales favoritas</p>
      `,
      showConfirmButton: false,
      showCloseButton: true,
      position: "top",
      onOpen: () => {
        const style = document.createElement("style");
        style.id = "swal-share-styles";
        style.innerHTML = `
          .swal-share-icon {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            border: 2px solid #0066cc;
            background: #ffffff;
            color: #0066cc;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s ease;
            text-decoration: none;
          }
          .swal-share-icon:hover,
          .swal-share-icon:focus {
            background: #0066cc;
            color: #ffffff;
            transform: scale(1.08);
            outline: none;
          }
          .swal-share-icon:active {
            transform: scale(0.95);
          }
        `;
        document.head.appendChild(style);

        const copyBtn = document.getElementById("swal-copy-btn");
        if (copyBtn) {
          copyBtn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            const tempInput = document.createElement("textarea");
            tempInput.value = roomLink;
            tempInput.style.position = "fixed";
            tempInput.style.top = "0";
            tempInput.style.left = "0";
            tempInput.style.opacity = "0";
            document.body.appendChild(tempInput);
            tempInput.focus();
            tempInput.select();
            let copied = false;
            try {
              copied = document.execCommand("copy");
            } catch (err) {
              copied = false;
            }
            document.body.removeChild(tempInput);
            if (!copied && navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(roomLink).catch(() => {});
            }
            const self = this;
            self.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> Copiado!';
            self.style.backgroundColor = "#3399ff";
            self.style.transform = "scale(1.05)";
            setTimeout(function () {
              self.style.transform = "scale(1)";
            }, 200);
          });
        }
      },
      willClose: () => {
        const style = document.getElementById("swal-share-styles");
        if (style) style.remove();
      },
    });
  }

  render() {
    //const roomData = {...this.props.roomData};

    return (
      <div className="subasta-room-container">
        <div className="subasta-room-header">
          {this.state.type_room === "1" && (
            <>
              <div className="subasta-room-type-icon">
                <img src={subastaRoomIcon} alt="Sala tipo Subasta" />
              </div>
              <div className="subasta-room-type-title">SUBASTA</div>
            </>
          )}
          {this.state.type_room === "2" && (
            <>
              <div className="subasta-room-type-icon">
                <img src={classicRoomIcon} alt="Sala tipo Subasta" />
              </div>
              <div className="subasta-room-type-title">CLÁSICA</div>
            </>
          )}
          {this.state.type_room === "5" && (
            <>
              <div className="subasta-room-type-icon">
                <img src={publicRoomIcon} alt="Sala tipo Subasta" />
              </div>
              <div className="subasta-room-type-title">PÚBLICA</div>
            </>
          )}
          <div className="subasta-room-status">
            {this.state.matchStatusText}
          </div>
        </div>
        <div className="subasta-room-match-name-container">
          <div className="subasta-room-match-name">{this.state.name}</div>
        </div>
        <div className="subasta-room-data-container">
          <div className="subasta-romm-data-row">
            <div className="subasta-room-data-title">PARTIDO:</div>
            <div className="subasta-room-data-field">
              {this.state.matchName}
            </div>
          </div>
          <div className="subasta-romm-data-row">
            <div className="subasta-room-data-title">FECHA:</div>
            <div className="subasta-room-data-field">
              {this.state.matchDate} - {this.state.matchHour}
            </div>
          </div>
          <div className="subasta-romm-data-row">
            <div className="subasta-room-btn-container">
              <Link
                to={"/Rooms/" + this.state.sku}
                className="btn btn-primary-small"
              >
                VER SALA
              </Link>
            </div>
            <div className="subasta-room-btn-container">
              <div
                className="btn btn-primary-small"
                onClick={this.copyRoomLink}
              >
                COMPARTIR
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RoomCard;
